
const Head = ({ title, abbv }) => {

  let titleText = ""

  if (abbv === false) {
    titleText = title + " | Jonah Lucy Heywood"
  } else {
    titleText = title + " | JLH"
  }
  
  return (
    <head>
      <title>{titleText}</title>

      <meta name="viewport" content="width=device-width, initial-scale=1.0"></meta>
      <link rel="icon" type="image/x-icon" href="/images/favicon.ico"></link>
      <link rel="preconnect" href="https://fonts.googleapis.com"></link>
      <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin></link>
      <link href="https://fonts.googleapis.com/css2?family=Karla:ital,wght@0,200..800;1,200..800&family=Lexend:wght@100..900&family=Quantico:ital,wght@0,400;0,700;1,400;1,700&display=swap" rel="stylesheet"></link>
    </head>
    
  );
}

export default Head;